import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import Card from '../common/Card';
import Button from '../common/Button';
import Modal from '../common/Modal';
import Input from '../common/Input';
import Loading from '../common/Loading';
import { useNavigate } from 'react-router-dom'; // ← Ajouter si manquant


const OwnerList = () => {
  const navigate = useNavigate(); // ← Ajouter
  const [owners, setOwners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
  });

  useEffect(() => {
    fetchOwners();
  }, []);

  const fetchOwners = async () => {
    try {
      const response = await api.get('/owners');
      setOwners(response.data.data);
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      await api.post('/owners', formData);
      setShowModal(false);
      setFormData({ name: '', email: '', password: '' });
      fetchOwners();
    } catch (error) {
      alert(error.response?.data?.message || 'Erreur lors de la création');
    }
  };

  const handleToggleActive = async (id) => {
    try {
      await api.patch(`/owners/${id}/toggle-active`);
      fetchOwners();
    } catch (error) {
      alert(error.response?.data?.message || 'Erreur');
    }
  };

  const handleDelete = async (id) => {
    if (
      window.confirm(
        'Êtes-vous sûr ? Cela supprimera aussi tous ses user_simples.'
      )
    ) {
      try {
        await api.delete(`/owners/${id}`);
        fetchOwners();
      } catch (error) {
        alert(error.response?.data?.message || 'Erreur lors de la suppression');
      }
    }
  };

  if (loading) return <Loading />;

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-gray-800">User Owners</h1>
        <Button onClick={() => setShowModal(true)}>+ Nouveau Owner</Button>
      </div>

      <Card>
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  Nom
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  Email
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  Statut
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {owners.map((owner) => (
                <tr key={owner._id}>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="w-10 h-10 rounded-full bg-green-500 text-white flex items-center justify-center font-bold">
                        {owner.name.charAt(0).toUpperCase()}
                      </div>
                      <div className="ml-4">
                        <div className="text-sm font-medium text-gray-900">
                          {owner.name}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {owner.email}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span
                      className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                        owner.active
                          ? 'bg-green-100 text-green-800'
                          : 'bg-red-100 text-red-800'
                      }`}
                    >
                      {owner.active ? 'Actif' : 'Inactif'}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm space-x-2">
                    <Button
                      variant="primary"
                      onClick={() => navigate(`/owners/${owner._id}/consumption`)} // ← NOUVEAU
                      className="text-xs"
                    >
                      📊 Consommation
                    </Button>
                    <Button
                      variant={owner.active ? 'danger' : 'success'}
                      onClick={() => handleToggleActive(owner._id)}
                      className="text-xs"
                    >
                      {owner.active ? 'Désactiver' : 'Activer'}
                    </Button>
                    <Button
                      variant="danger"
                      onClick={() => handleDelete(owner._id)}
                      className="text-xs"
                    >
                      Supprimer
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Modal Création */}
      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title="Créer un user_owner"
      >
        <form onSubmit={handleCreate}>
          <Input
            label="Nom"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
          />
          <Input
            label="Email"
            type="email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            required
          />
          <Input
            label="Mot de passe"
            type="password"
            value={formData.password}
            onChange={(e) =>
              setFormData({ ...formData, password: e.target.value })
            }
            required
          />
          <div className="flex justify-end space-x-3 mt-6">
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Annuler
            </Button>
            <Button type="submit">Créer</Button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default OwnerList;